import React from 'react'
import { Grid } from '@mui/material'
import FormikTextField from '../../../Formik/FormikTextField'
import InputAdornment from '@mui/material/InputAdornment'
import IconButton from '@mui/material/IconButton'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import FormikRecaptcha from '../../../Formik/FormikRecaptcha'
import FormikCheckbox from '../../../Formik/FormikCheckbox'
import { Link } from 'react-router-dom'
import { Trans, useTranslation } from 'react-i18next'
import { PRIVACY_POLICY_FLATPAGE_URL } from '../../../../urls'

const SignUpFormFields: React.FC<{
  handleClickPrivacyPolicy?(): void
}> = ({ handleClickPrivacyPolicy }) => {
  const { t } = useTranslation()
  const [showPassword, setShowPassword] = React.useState(false)
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FormikTextField name='firstName' label={t('formLabels.firstName', 'First name')} />
      </Grid>
      <Grid item xs={12}>
        <FormikTextField name='lastName' label={t('formLabels.lastName', 'Last name')} />
      </Grid>
      <Grid item xs={12}>
        <FormikTextField name='email' type='email' label={t('formLabels.email', 'Email')} required />
      </Grid>
      <Grid item xs={12}>
        <FormikTextField
          name='password'
          type={showPassword ? 'text' : 'password'}
          label={t('formLabels.password', 'Password')}
          required
          InputProps={{
            endAdornment: (
              <InputAdornment position='end'>
                <IconButton
                  aria-label='toggle password visibility'
                  onClick={() => {
                    setShowPassword(!showPassword)
                  }}
                  edge='end'
                >
                  {!showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <FormikRecaptcha name={'captcha'} />
      </Grid>
      <Grid item xs={12}>
        <FormikCheckbox
          name='subscriptions'
          formControlLabelProps={{
            label: t('formLabels.subscriptions', 'I wish to receive news on my e-mail'),
            control: null,
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <FormikCheckbox
          name='policyAgreement'
          formControlLabelProps={{
            label: (
              <span className='pt-5'>
                <Trans i18nKey='formLabels.policyAgreement'>
                  I have read and agree to the
                  <Link to={PRIVACY_POLICY_FLATPAGE_URL} onClick={handleClickPrivacyPolicy}>
                    <strong>Privacy policy</strong>
                  </Link>
                </Trans>
              </span>
            ),
            control: null,
          }}
        />
      </Grid>
    </Grid>
  )
}

export default SignUpFormFields
